import {css} from 'lit';
import {desktop, tablet} from '../../js/services/const';

export default css`
  ::selection {
    background: var(--brand);
    color: var(--brand-text);
  }

  :host {
    --autocomplete-search-block-padding: 0;
    --autocomplete-search-block-margin: 1.6rem 0;
    --autocomplete-position-finder-display: block;
    --autocomplete-suggestion-position: absolute;
    --autocomplete-suggestion-margin-top: 0;
    --autocomplete-error-padding: 0 0 1.2rem 0;

    display: block;
  }

  :host([mandant='webde']) .suggestion {
    border-color: var(--brand);
  }

  .search-block {
    display: flex;
    box-sizing: border-box;
    position: relative;
    padding: var(--autocomplete-search-block-padding);
    margin: var(--autocomplete-search-block-margin);
  }

  .searchbox {
    flex: 1;
    position: relative;
    width: 100%;
    min-width: 0;
    padding: 0;
  }

  .searchbox form {
    display: flex;
  }

  .searchbox.suggest-open .suggestion {
    display: block;
  }

  .searchbox.suggest-open input {
    border-radius: 4px 0 0 0;
    border-bottom: 0;
  }

  .searchbox input {
    min-width: 0;
    width: 100%;
    border-radius: 4px 0 0 4px;
    border-right: 0;
    margin: 0;
  }

  .searchbox form > div {
    flex: 1 1 auto;
    position: relative;
    min-width: 0;
  }

  .searchbox button {
    border-radius: 0 4px 4px 0;
    box-sizing: border-box;
    background-clip: padding-box;
    display: inline-block;
    height: 4rem;
    margin: 0;
  }

  .searchterm::placeholder {
    color: var(--cp-grey-light-3);
    font-style: italic;
  }

  .suggestion {
    display: none;
    box-sizing: border-box;
    border-radius: 0 0 4px 4px;
    box-shadow: 0 0.1rem 0.1rem rgba(0, 0, 0, 0.1);
    background-color: var(--form-default-background);
    position: var(--autocomplete-suggestion-position);
    top: 3.9rem;
    margin-top: var(--autocomplete-suggestion-margin-top); /** for when in infinite scroll and position is 'static'  */
    left: 0;
    border-left: 0.1rem solid;
    border-right: 0.1rem solid;
    border-bottom: 0.1rem solid;
    border-color: var(--form-element-default-border);
    z-index: 1;
    width: 100%;
  }

  .suggestion ul {
    padding-top: 0.8rem;
    border-top: 0.1rem solid var(--separator-default);
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    white-space: nowrap;
    max-height: 19.4rem;
  }

  .suggestion li {
    font-size: 1.6rem;
    line-height: 3.6rem;
  }

  .suggestion li.active a {
    color: var(--black);
    background-color: transparent; /** Reset normal Linkhover */
  }

  .suggestion a {
    display: block;
    padding-left: 1rem;
    color: var(--cp-grey-light-3);
  }

  .autocomplete-error {
    display: none;
    clear: both;
    color: var(--notification-error);
    padding: var(--autocomplete-error-padding);
  }

  .autocomplete-error.show {
    display: block;
  }

  .autocomplete__highlight {
    line-height: 1; /** fixes 1px height difference between browsers */
    font-weight: bold;
    color: var(--text-highVisibility);
  }

  .mod-sement,
  [data-mod-name='sement'] {
    border-bottom: 0;
  }

  .mod-sement .sement-topics,
  [data-mod-name='sement'] .sement-topics {
    margin-bottom: 0;
    padding: 0;
  }

  ul.sement-topics {
    width: 100%;
    overflow: hidden;
    margin-bottom: 2.4rem;
  }

  ul.sement-topics li {
    float: left;
    width: 100%;
    color: var(--link);
    box-sizing: border-box;
    margin-bottom: 0.5rem;
  }

  ul.sement-topics li:after {
    height: calc(var(--gap) / 2);
  }

  ul.sement-topics li a {
    display: inline-block;
    max-width: 100%;
    font-weight: 400;
    background-color: var(--link-bg);
    padding: calc(var(--gap) / 8) 1rem;
    color: var(--system-hyperlink);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
  }

  ul.sement-topics li a:hover {
    background-color: var(--link-bg-hover);
  }

  :host([for='sement']:not([mandant='webde'])) .searchterm:hover:enabled,
  :host([for='sement']:not([mandant='webde'])) .searchterm:focus:enabled {
    border-color: var(
      --complementary-color
    ); /** exception cause it must be the same color as the submit button */
  }

  :host([for='weather']) .position-finder {
    display: var(--autocomplete-position-finder-display);
    cursor: pointer;
    height: 4rem;
    width: 4rem;
    margin-right: 1rem;
    text-align: center;
    box-sizing: border-box;
    border: 1px solid var(--buttonTertiary-default-border);
    border-radius: 4px 4px 4px 4px;
    padding-right: 0;
    padding-left: 0;
    z-index: 1;
  }

  :host([for='weather']) .position-finder:hover {
    box-shadow: none;
    border-color: rgba(0, 0, 0, 0.3);
    background-color: var(--body-bg);
  }

  :host([for='weather']) .position-finder.animation {
    box-shadow: none;
    border: 0;
    border-radius: 0;
    background-color: var(--white);
  }

  :host([for='weather']) .position-finder.animation .icon.icon-spin {
    display: block;
  }

  :host([for='weather']) .position-finder.animation .icon.icon-position {
    display: none;
  }

  :host([for='weather']) .position-finder .icon.icon-position {
    line-height: 4rem;
    font-size: 2.4rem;
    display: block;
  }

  :host([for='weather']) .position-finder .icon.icon-spin {
    display: none;
  }

  /** Hide position finder on unsupported devices */
  :host([for='weather']) .position-finder.hidden {
    display: none;
  }

  @media (min-width: ${tablet}px) {
    ul.sement-topics li {
      padding: 0 var(--gap) 0 0;
      width: 33.33%;
      border-right: calc(var(--gap) / 2) solid transparent;
    }
  }

  @media (min-width: ${desktop}px) {
    .suggestion li {
      font-size: 1.6rem;
      line-height: 3rem;
    }
  }
`;
